var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('auth-split-layout',[_c(_vm.form,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }